import { render } from "./NotFound.vue?vue&type=template&id=08f4ea00&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=08f4ea00&scoped=true&lang=scss"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f4ea00"]])

export default __exports__